export default __webpack_public_path__ + "static/media/logo.83241ea3.svg";